import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { FormikProvider, useFormik } from 'formik'
import { Button, DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog, Stack } from '@mui/joy'
import { sendMessageToUsersSchema } from 'validations/sms/sendMessageToUsersSchema'
import { SEND_MESSAGE_TYPES, SEND_MESSAGE_TYPES_ARRAY } from 'utils/config'
import CustomEditorControl from 'components/forms/CustomEditorControl'
import CustomRadioControl from './forms/CustomRadioControl'
import CustomInputControl from './forms/CustomInputControl'

const MessageUsersModal = ({ open, setObject, handleSubmit, title = 'Wyslij wiadomość', children, loading }) => {
  const formik = useFormik({
    initialValues: { message: '', subject: '', type: SEND_MESSAGE_TYPES.sms.value },
    validationSchema: sendMessageToUsersSchema,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    formik.resetForm()
  }, [open])

  return (
    <Modal open={Boolean(open)} onClose={() => setObject(false)}>
      <ModalDialog variant="outlined" role="alertdialog" sx={{ maxWidth: '500px', width: '100%' }}>
        <DialogTitle>{title}</DialogTitle>
        <Divider />
        <DialogContent>{children}</DialogContent>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <Stack spacing={2}>
              <CustomRadioControl
                name="type"
                label="Rodzaj wiadomości"
                options={SEND_MESSAGE_TYPES_ARRAY}
                formik={formik}
                orientation="horizontal"
              />
              {formik.values.type === SEND_MESSAGE_TYPES.email.value && (
                <CustomInputControl name="subject" label="Tytuł email" formik={formik} />
              )}
              <CustomEditorControl name="message" label="Treść wiadomości" formik={formik} />
            </Stack>
          </form>
        </FormikProvider>
        <DialogActions>
          <Button
            variant="solid"
            color="primary"
            onClick={formik.handleSubmit}
            loading={loading}
            disabled={!formik.isValid || loading}
          >
            Wyślij wiadomość
          </Button>
          <Button variant="plain" color="neutral" onClick={() => setObject(false)} disabled={loading} loading={loading}>
            Anuluj
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  )
}

MessageUsersModal.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.array]).isRequired,
  setObject: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  loading: PropTypes.bool,
}

export default MessageUsersModal
